import players from "../jsonData/simulatorLineupData_COL.json";
import shareImage from "../../../assets/selection-col/seleccion-col-share.jpg";
import teamImage from "../../../assets/selection-col/team-col.png";

export const lineupCOLConfig = {
  players,
  title: "Arma tu 11 ideal de la Selección de Colombia",
  accentColor: "#f5313f",
  pitchColor: ["#1a6b2e", "#155a26"],
  nameColor: "var(--color-black)",
  lastNameColor: "#f5313f",
  shareImage,
  teamImage,
  backgroundTeam: "#043610b0",
  shareUrl: "futbol/mundial-2026/arma-tu-alineacion-ideal-de-colombia-para-el-mundial-2026-con-el-simulador-de-claro-sports/",
  shareText: "Mi 11 ideal de la selección de Colombia ",
  shareTitle: "Mi 11 ideal de la selección de Colombia ",
  shareFileName: "mi-11-ideal-col.png",
  showClubToggle: false, // Mostrar botón para ver/ocultar club
  showNationalityToggle: false, // Mostrar botón para ver/ocultar nacionalidad
  selectionPath: "selection-col", // Ruta de la carpeta de assets de la selección
  showFormationFilter: true, // Mostrar dropdown de alineación
  defaultFormation: "4-3-3", // Alineación por defecto
};